import { cloneDeep } from "lodash";
import { ReportIRBOFilterOptions } from "./options/ReportIRBOFilterOptions";
import { Indicator } from "../../common/types/Indicator";
import { ReportIRBOFilterSettings } from "./settings/ReportIRBOFilterSettings";
import { Template } from "../../common/types/Template";
import { allClassificationTypesOptions, allDataSourcesOptions, allMeasureUnitsOptions, allMutuallyRedeemingLevelOptions, allMutuallyRedeemingOptions, allPeriodicitiesOptions, allReportNamesOptions, allReportTypesOptions } from "../../common/baseOptions";

export const reportIRBOIndicators: Indicator[] = [
    { key: 'skor_plan', active: true },
    { key: 'plan_na_period', active: true },
    { key: 'kass', active: true },
    { key: 'unfulfilled', active: true },
    { key: 'percent_to_period', active: true },
    { key: 'deviation_from_annual', active: true },
    { key: 'percent_to_year', active: true },
]


// Нужна как временная затычка (При созданий нового берутся пустые настройки)
const tempSettings: ReportIRBOFilterSettings = {
    // Base:
    reportName: 'IRBO',
    reportType: 'REGULATED',
    classificationType: 'EXPENSES',
    dataSource: 'IISK',
    periodicity: 'DAY',
    // Custom:
    date: '',
    region: '',
    measureUnit: 'TENGE',
    mutuallyRedeeming: 'WITHOUT',
    mutuallyRedeemingLevels: [],
    decodingActualRegionalbudget: true,
    roundUpTo: null,
    indicators: cloneDeep(reportIRBOIndicators),
    sortByRegionCode: false
}

export const reportIRBOBaseTemplate: Template = {
    id: null,
    name: 'Информация об исполнении расходов бюджета',
    excelName: null,
    description: null,
    category: '50',
    regions: [],
    userId: '',
    filterSettings: tempSettings
}


export const reportIRBOFilterOptions: ReportIRBOFilterOptions = {
    // Base:
    key: 'IRBO',
    reportNames: cloneDeep(allReportNamesOptions),
    reportTypes: cloneDeep(allReportTypesOptions),
    classificationTypes: cloneDeep(allClassificationTypesOptions),
    dataSources: cloneDeep(allDataSourcesOptions).filter(it => it.value !== 'LOADER'),
    periodicities: cloneDeep(allPeriodicitiesOptions),
    // Custom:
    regions: [], // Загружается с бэка
    mutuallyRedeeming: cloneDeep(allMutuallyRedeemingOptions),
    mutuallyRedeemingLevels: cloneDeep(allMutuallyRedeemingLevelOptions),
    measureUnits: cloneDeep(allMeasureUnitsOptions),
    indicators: cloneDeep(reportIRBOIndicators),
}
